<template>
  <el-dialog
    :visible.sync="visible"
    id="one1"
    append-to-body
    width="1300px"
    :title="'查看手册'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="admin">
      <!--<img
              width="100%"
              :src="dataForm.manualCover"
              alt=""
      >-->
      <el-button
        type="primary"
        size="small"
        v-on:click="printOut(studentName + '学生争章手册')"
        style="margin-bottom: 30px"
        >导出PDF</el-button
      >
      <!--<el-button type="primary" size="small"   v-on:click="exportStudents" style="margin-bottom: 30px">导出班级所有学生</el-button>-->
      <div
        :style="
          'background-image:url(' + http2https(dataForm.manualCover) + ');'
        "
        class="ground"
        style="margin-bottom: 60px"
      >
        <el-form
          :model="dataForm"
          id="selectForm"
          :rules="dataRule"
          ref="dataForm"
          @keyup.enter.native="dataFormSubmitHandle()"
          :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'"
        >
          <h2>
            姓&#12288;&#12288;名：
            <span class="line0">{{ studentName }}</span>
          </h2>
          <h2>
            队&#12288;&#12288;籍：
            <span class="line0">{{ className }}</span>
          </h2>
        </el-form>
        <!--dataForm.manualBackground-->
      </div>
      <div
        class="wrapper ground"
        :style="
          'background-image:url(' + http2https(dataForm.manualBackground) + ');'
        "
        style="display: flex;margin-bottom: 60px"
      >
        <div class="left">
          <h3
            style="text-align: center;font-weight: bolder;font-size: 26px;color: #AD0306"
          >
            争红领巾奖章，做新时代好队员
          </h3>
          <p style="font-weight: bolder">亲爱的小伙伴</p>
          <p class="pclass">
            欢迎你加入红领巾奖章争章队伍，与全国的少年儿童们一起勇闯关，争奖章，赢荣誉
          </p>
          <p class="pclass">
            当你进入小学，红领巾奖章作为少先队特有的奖章就开始伴随着你成长。一枚枚的奖章就是一个个富有挑战的目标，争章的过程就是挑战自我，战胜自我的过程。低年级时，你在争章中表现优异，闯过入队关，
            带上鲜艳的红领巾。中年级时，你积极参与少先队活动，在少先队组织里不断进步，集齐12枚基础章变成了一个小目标。闯过基础关后，你开始朝着星级迈进。高年级时，你成为队员中的大哥哥或大姐姐，也许你已经拿到了一星章
            、二星章、三星...成为中低年级队员的好榜样，也许你还在不断争取着，做一名争章小先锋。无论如何，一枚红领巾奖章都会记录下你的努力与成长过程。
          </p>
          <p class="pclass">
            这本《红领巾奖章争章手册》将陪伴你六年，他将记录下你的小学生涯的成长记录，成为独一无二的成长纪念册，请好好爱护、好好珍藏。
          </p>
          <p class="pclass">
            希望你从现在开始，发扬少先队诚实、勇敢、团结、活泼的作风，用自己的努力去获得的一枚枚红领巾奖章，去积极争取少先队的荣誉，做一名新时代的好队员。
          </p>
          <p class="pclass">加油，好少年！</p>
          <p class="pclass">————中国少年先锋队福建省工作委员会</p>
        </div>
        <div class="right">
          <h3
            style="text-align: center;font-weight: bolder;font-size: 26px;color: #AD0306"
          >
            我的小档案
          </h3>
          <p style="color: #AD0306;font-weight: bolder">个人小名片</p>
          <el-row class="margin2">
            <el-col :span="10">
              姓&#12288;&#12288;名：
              <span class="line">{{ studentName }}</span>
            </el-col>
            <el-col :span="10">
              性别：
              <span class="line">
                <span v-if="studentSex === 0">男</span>
                <span v-if="studentSex === 1">女</span>
              </span>
            </el-col>
            <el-col :span="10">
              出生年月：
              <span class="line">{{ studentForm.birthDay }}</span>
            </el-col>
            <el-col :span="10">
              民族：
              <span class="line">{{ studentForm.nation }}</span>
            </el-col>
            <el-col :span="20" style="height: 40px;line-height: 40px">
              联系电话：
              <span class="line1">{{ studentForm.contactNumber }}</span>
            </el-col>
            <el-col :span="20">
              家庭住址：
              <span class="line1">{{ studentForm.familyAddress }}</span>
            </el-col>
          </el-row>
          <p style="color: #AD0306;font-weight: bolder">入队梦想卡</p>
          <el-row style="letter-spacing: 2px">
            <el-col :span="23" style="vertical-align: center">
              我是中国少年少先队
              <span class="line2">{{ schoolForm.province }}</span
              >省 <span class="line2">{{ schoolForm.city }}</span
              >市 <span class="linexian">{{ schoolForm.area }}</span
              >县 <span class="linedadui">{{ schoolForm.schoolName }}</span
              >大队 <span class="line2">{{ className }}</span
              >中队队员。
            </el-col>
            <el-col :span="22" style="vertical-align: center">
              大队辅导员：
              <span class="line2">{{ schoolForm.principal }}</span
              >中队辅导员
              <span class="line2">{{ headTeacherName }}</span>
            </el-col>
            <el-col :span="22" style="vertical-align: center">
              入队时间：
              <span class="line4">{{ studentForm.joinTeamDate }}</span
              >入队地点
              <span class="line2">{{ studentForm.joinTeamAddress }}</span>
            </el-col>
            <el-col :span="22" style="vertical-align: center">
              我的梦想：
              <span class="line3">{{ studentForm.studentDream }}</span>
              <!--<span class="line3" style="width: 545px;display: inline-block;height: 25px;border-bottom: 2px solid #1d1e1f"></span>-->
            </el-col>
          </el-row>
          <h3
            style="text-align: center;font-weight: bolder;font-size: 26px;color: #AD0306"
          >
            习总书记寄语
          </h3>
          <p class="pclass">
            新时代的少先队员需要热爱祖国，热爱任命，热爱中国共产党，树立远大理想，培养优良品德，勤奋学习知识，锻炼强健体魄，
            培养劳动精神，从小学先锋，长大做先锋，努力成长为能够担当名族伟大复兴大人的时代新人。
          </p>
          <p class="pclass">
            -----摘自习近平总书记致中国少年先锋队建队70周年的贺信
          </p>
        </div>
      </div>
      <div
        :style="
          'background-image:url(' + http2https(dataForm.manualBackground) + ');'
        "
        style="display: flex;margin-bottom: 60px"
        class="ground"
      >
        <div class="borderLine">
          <h3
            style="text-align: center;font-weight: bolder;font-size: 24px;padding-top: 50px;color: #AD0306"
          >
            {{ termName }}奖章争章榜
          </h3>
          <el-row
            class="margin1"
            style="border-bottom: none;font-weight: bolder;font-size: 18px"
          >
            <el-col :span="2">
              <div
                :style="wordOfMouthIOSDivStyled"
                style="vertical-align: center;writing-mode:vertical-rl;"
              >
                <p
                  style="writing-mode:vertical-rl;text-align: center;vertical-align: center;margin-left: -10px"
                >
                  基础章
                </p>
              </div>
            </el-col>
            <el-col :span="22">
              <!--<el-row v-for="(chl, i) in decorationNameList" :key="i">-->
              <el-col :span="24" style="display: flex">
                <div
                  style="height: 30px;width: 86%;text-align: center;border-right: 2px solid #E97B33;"
                >
                  获章标准
                </div>
                <div style="height: 30px;width: 15%;text-align: center">
                  状态
                </div>
              </el-col>
              <div
                style="width: 100%;font-size: 14px"
                v-for="decoration in decorationList"
                :key="decoration.id"
              >
                <el-col :span="2">
                  <div
                    style="writing-mode:vertical-rl;text-align: center;vertical-align: center;width:70%;align: center"
                    :style="
                      'height:' +
                        (60 * decoration.studentTaskDTOS.length +
                          decoration.studentTaskDTOS.length *
                            (decoration.studentTaskDTOS.length > 1 ? 1 : 0)) +
                        'px'
                    "
                  >
                    {{ decoration.decorationName }}
                  </div>
                </el-col>

                <el-col
                  :span="22"
                  style="display: flex"
                  v-for="(task, index) in decoration.studentTaskDTOS"
                  :key="task.id"
                >
                  <div
                    style="height: 60px;width: 84%;border-right: 2px solid #E97B33;letter-spacing: 1px;font-weight: normal"
                  >
                    {{ task.taskContent }}
                  </div>
                  <div style="height: 60px;width: 15%">
                    <img
                      crossorigin="anonymous"
                      style="width: 80px"
                      v-show="task.isTask === 1"
                      src="@/assets/img/pro.png"
                    />
                    <img
                      crossorigin="anonymous"
                      style="width: 80px"
                      v-show="task.isTask === 0"
                      src="@/assets/img/unpro.png"
                    />
                    <img
                      crossorigin="anonymous"
                      style="width: 80px"
                      v-show="task.isTask === 2"
                      src="@/assets/img/unpro.png"
                    />
                    <img
                      crossorigin="anonymous"
                      style="width: 80px"
                      v-show="task.isTask === 3"
                      src="@/assets/img/unpro.png"
                    />
                    <img
                      crossorigin="anonymous"
                      style="width: 80px"
                      v-show="task.isTask === 4"
                      src="@/assets/img/unpro.png"
                    />
                    {{ filterTime(task.taskTime) }}
                  </div>
                </el-col>
              </div>
              <!--</el-row>-->
              <!--</el-row>-->
            </el-col>
            <!--<el-col :span="20" >
                    <div :style="wordOfMouthIOSDivStyle">
                        <p style="vertical-align: center;margin-top: 30px;margin-left: -5px">基础章</p>
                    </div>
            </el-col>-->
          </el-row>
          <el-row style="border-bottom: none">
            <el-col :span="2">
              <div :style="wordOfMouthIOSDivStyle">
                <p
                  style="vertical-align: center;margin-top: 10px;margin-left: -5px;font-weight: bolder;font-size: 18px"
                >
                  特色章
                </p>
              </div>
            </el-col>
            <el-col :span="22">
              <!--<el-row v-for="(chl, i) in decorationNameList" :key="i">-->
              <div :style="ratingSubDivStyle"></div>
              <!--</el-row>-->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <div :style="wordOfMouthIOSDivStyle">
                <p
                  style="vertical-align: center;margin-top: 10px;margin-left: -5px;font-weight: bolder;font-size: 18px"
                >
                  星级章
                </p>
              </div>
            </el-col>
            <el-col :span="22">
              <!--<el-row v-for="(chl, i) in decorationNameList" :key="i">-->
              <div :style="ratingSubDivStyle"></div>
              <!--</el-row>-->
            </el-col>
          </el-row>
          <!-- <h3 style="text-align: center;font-weight: bolder;font-size: 24px;color: #AD0306">争章感悟</h3>
            <el-row  class="margin1">
                &lt;!&ndash; <el-col :span="2" >
                     <div :style="wordOfMouthIOSDivStyle">
                         <p style="vertical-align: center;margin-top: 30px;margin-left: -5px">基础章</p>
                     </div>
                 </el-col>&ndash;&gt;
                <el-col :span="24" >
                    &lt;!&ndash;<el-row v-for="(chl, i) in decorationNameList" :key="i">&ndash;&gt;
                    <div :style="ratingSubDivStyle1">

                    </div>
                    &lt;!&ndash;</el-row>&ndash;&gt;
                </el-col>
          </el-row>-->
        </div>
        <div class="borderLine" style="margin-top: 50px">
          <h3
            style="text-align:center;font-weight: bolder;font-size: 24px;color: #AD0306"
          >
            {{
              decorationList.length > 0 ? decorationList[0].decorationName : ''
            }}争章足迹
          </h3>
          <el-row class="margin1">
            <el-col :span="24">
              <div :style="ratingSubDivStyle2">
                <div v-if="this.isFootImg === '1'">
                  <div
                    style="display: inline-block"
                    v-show="decoration !== '' && decoration !== null"
                    v-for="task in decoration.studentTaskDTOS"
                    :key="task.id"
                  >
                    <img
                      crossorigin="anonymous"
                      style="width: 150px; height: 150px;vertical-align: center;margin-left: 10px"
                      v-for="url in task.imgList"
                      v-show="task.imgList.length !== 0"
                      :key="url"
                      :src="http2https(url)"
                    />
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div
        v-if="decorationList.length >= 2"
        :style="
          'background-image:url(' + http2https(dataForm.manualBackground) + ');'
        "
        style="display: flex;margin-bottom: 60px"
        class="ground"
      >
        <div
          class="borderLine"
          style="margin-top: 50px"
          v-for="dec in decorationLists"
          :key="dec.id"
        >
          <h3
            style="text-align:center;font-weight: bolder;font-size: 24px;color: #AD0306"
          >
            {{ dec.decorationName }}争章足迹
          </h3>
          <el-row class="margin1">
            <el-col :span="24">
              <div :style="ratingSubDivStyle2">
                <div
                  style="display: inline-block"
                  v-for="task in dec.studentTaskDTOS"
                  :key="task.id"
                >
                  <img
                    crossorigin="anonymous"
                    style="width: 150px; height: 150px;vertical-align: center;margin-left: 10px"
                    v-for="url in task.imgList"
                    v-show="task.imgList.length !== 0 && isFootImg == 1"
                    :key="url"
                    :src="http2https(url)"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div
        v-if="decorationList.length >= 4"
        :style="'background-image:url(' + http2https(dataForm.manualBackground) + ');'"
        style="display: flex;margin-bottom: 60px"
        class="ground"
      >
        <div
          class="borderLine"
          style="margin-top: 50px"
          v-for="dec in decorationLists1"
          :key="dec.id"
        >
          <h3
            style="text-align:center;font-weight: bolder;font-size: 24px;color: #AD0306"
          >
            {{ dec.decorationName }}争章足迹
          </h3>
          <el-row class="margin1">
            <el-col :span="24">
              <div :style="ratingSubDivStyle2">
                <div
                  style="display: inline-block"
                  v-for="task in dec.studentTaskDTOS"
                  :key="task.id"
                >
                  <img
                    crossorigin="anonymous"
                    style="width: 150px; height: 150px;vertical-align: center;margin-left: 10px"
                    v-for="url in task.imgList"
                    v-show="task.imgList.length !== 0 && isFootImg == 1"
                    :key="url"
                    :src="http2https(url)"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div
        class="ground"
        style="display: flex;margin-bottom: 10px"
        :style="'background-image:url(' + http2https(dataForm.manualBackground) + ');'"
      >
        <div class="borderLine">
          <h3
            style="text-align: center;font-weight: bolder;font-size: 24px;padding-top: 50px;color: #AD0306"
          >
            {{ termName }}奖章争章榜
          </h3>
          <el-row class="margin1" style="border-bottom: none">
            <el-col :span="2">
              <div :style="wordOfMouthIOSDivStyle">
                <p
                  style="vertical-align: center;margin-top: 30px;margin-left: -5px;font-weight: bolder"
                >
                  基础章
                </p>
              </div>
            </el-col>
            <el-col :span="22">
              <div :style="ratingSubDivStyle">
                <div v-if="this.isDecorationImg === '1'">
                  <img
                    style="width: 100px; height: 100px;vertical-align: center;margin-left: 10px"
                    v-for="decoration in decorationList"
                    v-show="decoration.isDecoration === 1"
                    :key="decoration.id"
                    :src="http2https(decoration.imgUrl)"
                  />
                </div>
              </div>
              <!--</el-row>-->
            </el-col>
          </el-row>
          <el-row style="border-bottom: none">
            <el-col :span="2">
              <div :style="wordOfMouthIOSDivStyle">
                <p
                  style="vertical-align: center;margin-top: 30px;margin-left: -5px;font-weight: bolder"
                >
                  特色章
                </p>
              </div>
            </el-col>
            <el-col :span="22">
              <div :style="ratingSubDivStyle"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <div :style="wordOfMouthIOSDivStyle">
                <p
                  style="vertical-align: center;margin-top: 30px;margin-left: -5px;font-weight: bolder"
                >
                  星级章
                </p>
              </div>
            </el-col>
            <el-col :span="22">
              <!--<el-row v-for="(chl, i) in decorationNameList" :key="i">-->
              <div :style="ratingSubDivStyle"></div>
              <!--</el-row>-->
            </el-col>
          </el-row>
          <h3
            style="text-align: center;font-weight: bolder;font-size: 24px;color: #AD0306"
          >
            争章感悟
          </h3>
          <el-row class="margin1">
            <!-- <el-col :span="2" >
                  <div :style="wordOfMouthIOSDivStyle">
                      <p style="vertical-align: center;margin-top: 30px;margin-left: -5px">基础章</p>
                  </div>
            </el-col>-->
            <el-col :span="24">
              <!--<el-row v-for="(chl, i) in decorationNameList" :key="i">-->
              <div :style="ratingSubDivStyle1"></div>
              <!--</el-row>-->
            </el-col>
          </el-row>
        </div>
        <div class="borderLine" style="margin-top: 50px">
          <h3
            style="text-align:center;font-weight: bolder;font-size: 24px;color: #AD0306"
          >
            成长与收获
          </h3>
          <el-row class="margin1">
            <!-- <el-col :span="2" >
                       <div :style="wordOfMouthIOSDivStyle">
                           <p style="vertical-align: center;margin-top: 30px;margin-left: -5px">基础章</p>
                       </div>
            </el-col>-->
            <el-col :span="24">
              <!--<el-row v-for="(chl, i) in decorationNameList" :key="i">-->
              <div :style="ratingSubDivStyle2">
                <!-- <div style="display: inline-block" v-for="decoration in decorationList" :key="decoration.id">
                              <img style="width: 150px; height: 150px;vertical-align: center;margin-left: 10px" v-for="task in decoration.studentTaskDTOS" v-show="task.imgSrc!==null" :key="task.id" :src="task.imgSrc">
                </div>-->
              </div>
              <!--</el-row>-->
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Template from '../devtools/template'
import moment from 'moment'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  components: { Template },
  data() {
    return {
      visible: false,
      manualCover: '',
      background: '',
      width: '100%',
      studentName: '',
      termName: '',
      className: '',
      studentSex: '',
      studentId: '',
      schoolId: '',
      headTeacherName: '',
      decorationList: [],
      decoration: {},
      decorationLists: [],
      decorationLists1: [],
      miniDivHeight: 140,
      ratingSubDivHeight: 140,
      isFootImg: '',
      isDecorationImg: '',
      isTempFootImg: '',
      isTempDecorationImg: '',
      decorationNameList: ['基础章', '特色章', '星级章'],
      dataForm: {
        id: '',
        manualCover: '',
        manualBackground: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        schoolId: '',
        termId: '',
        studentId: ''
      },
      studentForm: {
        id: '',
        studentId: '',
        studentName: '',
        birthDay: '',
        studentSex: '',
        nation: '',
        familyAddress: '',
        joinTeamDate: '',
        studentJob: '',
        joinTeamAddress: '',
        contactNumber: '',
        studentDream: ''
      },
      exportPDFtitle: '学生手册',
      schoolForm: {
        id: '',
        schoolName: '',
        schoolCode: '',
        principal: '',
        principalPhone: '',
        province: '',
        city: '',
        area: ''
      },
      studentList: [],
      classId: ''
    }
  },
  computed: {
    wordOfMouthIOSDivStyle: function() {
      var height = this.miniDivHeight
      return `padding: 20px;height: ${height}px;vertical-align: center;`
    },
    wordOfMouthIOSDivStyled: function() {
      var size = 0
      for (let i = 0; this.decorationList.length > i; i++) {
        size += this.decorationList[i].studentTaskDTOS.length
      }
      var height = 60 * size + size * 2 + 31
      return `padding: 20px;height: ${height}px;vertical-align: center;`
    },
    ratingSubDivStyle: function() {
      var height = this.ratingSubDivHeight
      return `padding: 20px;height: ${height}px`
    },
    ratingSubDivStyle1: function() {
      var height = 280
      return `padding: 20px;height: ${height}px`
    },
    ratingSubDivStyle2: function() {
      var height = 790
      return `padding: 20px;height: ${height}px`
    },
    dataRule() {
      return {}
    }
  },
  methods: {
    // 获取信息
    getIsImageConfig() {
      this.$http
        .get('/decoration/exportConfig/getSchoolConfig')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.isFootImg = res.data.isFootImg
          this.isDecorationImg = res.data.isDecorationImg
        })
        .catch(() => {})
    },
    exportStudents() {
      for (let i = 0; i < this.studentList.length; i++) {
        this.studentId = this.studentList[i].id
        this.getStudentStatusInfo()
        this.printOut(this.studentList[i].studentName + '学生争章手册')
      }
    },
    getStudentList() {
      this.$http
        .get('/student/student/getMyClassStudentList/' + this.classId)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.studentList = res.data
        })
        .catch(() => {})
    },
    // 获取学校信息
    getSchoolInfo() {
      this.$http
        .get('/school/school/' + this.schoolId)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.schoolForm = {
            ...this.schoolForm,
            ...res.data
          }
        })
        .catch(() => {})
    },
    getStudentStatusInfo() {
      this.$http
        .get(
          `student/studentStatusInfo/getStudentStatusInfoByStudentId/${this.studentId}`
        )
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          if (!res.data) {
            return
          }
          this.studentForm = res.data
          /* for (const key in this.dataForm) {
          this.dataForm[key] = this.dataForm[key].toString()
        } */
        })
    },
    printOut(name) {
      console.log(document.body.scrollTop)
      document.body.scrollTop = 0
      this.isTempFootImg = this.isFootImg
      this.isTempDecorationImg = this.isDecorationImg
      this.$nextTick(() => {
        const shareContent = document.querySelector('.el-dialog') // 需要截图的包裹的（原生的）DOM 对象
        // const width = 1650 // 获取dom 宽度
        const width = shareContent.clientWidth + 820 // 获取dom 宽度
        console.log(width)
        // const height = 5400// 获取dom 高度
        const height = shareContent.clientHeight * 1.262 // 获取dom 高度
        console.log(height)
        const canvas = document.createElement('canvas') // 创建一个canvas节点
        const scale = 1.61 // 定义任意放大倍数 支持小数
        const scale1 = 1.285 // 定义任意放大倍数 支持小数
        canvas.width = width * scale // 定义canvas 宽度 * 缩放
        canvas.height = height * 1.63 // 定义canvas高度 *缩放
        canvas.style.width = shareContent.clientWidth * scale + 'px'
        canvas.style.height = shareContent.clientHeight * scale1 + 'px'
        // canvas.style.width = 1600 * scale + 'px'
        // canvas.style.height = 4800 * scale + 'px'
        canvas.getContext('2d').scale(scale, scale1) // 获取context,设置scale
        const opts = {
          scale: scale, // 添加的scale 参数
          canvas: canvas, // 自定义 canvas
          logging: false, // 日志开关，便于查看html2canvas的内部执行流程
          width: width, // dom 原始宽度
          height: height,
          allowTaint: true,
          backgroundColor: '#FFFFFF',
          useCORS: true // 【重要】开启跨域配置
        }

        html2Canvas(shareContent, opts).then(() => {
          var contentWidth = canvas.width
          var contentHeight = canvas.height
          // 一页pdf显示html页面生成的canvas高度;
          var pageHeight = (contentWidth / 841.89) * 595.28
          // 未生成pdf的html页面高度
          var leftHeight = contentHeight
          // 页面偏移
          var position = -60
          // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 841.89
          var imgHeight = (841.89 / contentWidth) * contentHeight
          var pageData = canvas.toDataURL('image/jpeg', 1.0)
          var PDF = new JsPDF('l', 'pt', 'a4')
          console.log(leftHeight)
          console.log(pageHeight)
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 5, -60, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 5, position, imgWidth, imgHeight)
              leftHeight -= pageHeight + 60
              position -= 595.28
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(name + '.pdf') // 这里是导出的文件名
        })
      })
    },
    filterTime(time) {
      if (time === null) {
        return ''
      }
      return moment(time).format('YYYY-MM-DD')
    },
    init() {
      this.visible = true
      this.getIsImageConfig()
      this.$nextTick(() => {
        this.getInfo()
        this.getInfoList()
        this.getStudentList()
        this.manualCover = this.dataForm.manualCover
        this.background = this.dataForm.manualBackground
      })
    },
    getInfoList() {
      this.$http
        .get('/decoration/studentDecoration/getDecorationTaskList', {
          params: {
            termId: this.dataForm.termId,
            studentId: this.dataForm.studentId
          }
        })
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.decorationList = data.data
          this.decorationLists = []
          this.decorationLists1 = []
          for (let i = 0; i < this.decorationList.length; i++) {
            if (i === 0) {
              this.decoration = this.decorationList[0]
            }
            if (i > 0 && i < 3) {
              this.decorationLists.push(this.decorationList[i])
            }
            if (i > 2 && i < 5) {
              this.decorationLists1.push(this.decorationList[i])
            }
          }
          console.log(this.decorationLists)
        })
    },
    // 获取信息
    getInfo() {
      this.$http
        .get('/decoration/manualConfig/getSchoolConfig')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
          this.getStudentStatusInfo()
          this.getSchoolInfo()
        })
        .catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs.dataForm.validate(valid => {
          if (!valid) {
            return false
          }
          this.$http[!this.dataForm.id ? 'post' : 'put'](
            '/decoration/manualConfig/',
            this.dataForm
          )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    // http转https
    http2https(url) {
      const reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
      url = url.replace(reg, 'https://$2$3$4$5$6')
      return url
    }
  }
}
</script>
<style scoped lang="scss">
.back {
  background-image: url('../../../assets/img/1.jpg');
}
.line0 {
  display: inline-block;
  text-align: center;
  width: 150px;
  height: 33px;
  border-bottom: 2px solid #9e5d57;
}
.line {
  display: inline-block;
  text-align: center;
  width: 150px;
  height: 30px;
  border-bottom: 1px solid #1d1e1f;
}
.line1 {
  display: inline-block;
  text-align: center;
  width: 300px;
  height: 30px;
  border-bottom: 1px solid #1d1e1f;
}
.line2 {
  display: inline-block;
  text-align: center;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 5px;
  width: 150px;
  height: 27px;
  border-bottom: 1px solid #1d1e1f;
}
.linexian {
  display: inline-block;
  text-align: center;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 5px;
  width: 70px;
  height: 27px;
  border-bottom: 1px solid #1d1e1f;
}
.linedadui {
  display: inline-block;
  text-align: center;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 5px;
  width: 230px;
  height: 27px;
  border-bottom: 1px solid #1d1e1f;
}
.line4 {
  display: inline-block;
  text-align: center;
  margin-left: 6px;
  margin-right: 6px;
  width: 160px;
  margin-bottom: 5px;
  height: 30px;
  border-bottom: 1px solid #1d1e1f;
}
.line3 {
  width: 520px;
  // text-decoration: underline 1px solid #1d1e1f;
  //  text-underline-offset: 5px;
  //  padding-bottom: 3px;
  display: inline;
  margin-right: 5px;
  // border-bottom: 1px solid #1d1e1f;
}
@keyframes rotate {
  100% {
    transform: rotate(90deg);
  }
}
.margin1 {
}
.borderLine {
  margin-left: 20px;
  width: 48%;
  .el-row {
    margin-bottom: 0px; /*去除el-row之间的间距*/
    border: 2px solid #e97b33;
    margin: -1px -1px -1px -1px; /*解决相邻边框重叠问题就靠这行代码*/
    &:last-child {
      margin-bottom: 0px;
      margin: -1px -1px -1px -1px;
    }
    .el-col {
      border: 1px solid #e97b33;
    }
  }
}
.box1 {
  display: flex;
  width: 400px;
  height: auto;
  background: #2d64b3;
  border: 1px solid #1d1e1f;
}
.box2-1 {
  width: 100px;
  height: 20px;
  background: #11c26d;
  border: 1px solid #1d1e1f;
  /*display: flex;*/
}
.box3-1 {
  width: 100px;
  height: 20px;
  background: #11c26d;
  border: 1px solid #1d1e1f;
}
.box3-2 {
  width: 100px;
  height: 20px;
  background: #11c26d;
  border: 1px solid #1d1e1f;
}
.box2-2 {
  width: 100px;
  height: 20px;
  background: #ccc;
}
.box2-3 {
  width: 100px;
  height: 20px;
  background: #11c26d;
}
.pclass {
  text-indent: 2em;
  letter-spacing: 2px;
}
.wrapper {
  position: relative;
  width: 100%;
}

.left {
  margin-right: 20px;
  margin-left: 20px;
  margin-top: 50px;
  left: 0;
  width: 46%;
  color: #1d1e1f;
  font-size: 18px;
}

.right {
  margin-left: 5%;
  margin-top: 50px;
  color: #1d1e1f;
  font-size: 18px;
  width: 50%;
  height: 200px;
  /*必须有*/
  .el-row {
    .el-col {
    }
  }
}
#selectForm .el-form-item__label {
  font-size: 20px;
  font-weight: bolder;
  color: #9e5d57;
}
#selectForm {
  position: absolute;
  top: 700px;
  right: 280px;
  font-weight: bolder;
  color: #9e5d57;
}
.ground {
  width: 100%;
  height: 1100px;
  background-size: 100% 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
